<template>
  <div
    class="tab-pane fade"
    id="nav-RecentCoaching"
    role="tabpanel"
    aria-labelledby="nav-RecentCoaching-tab"
    tabindex="0"
  >
    <div class="table-responsive table-datatble">
      <a-table class="table datatable" :columns="columns" :data-source="data">
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'CoachName'">
            <h2 class="table-avatar">
              <a href="javascript:void(0);" class="avatar avatar-sm flex-shrink-0"
                ><img
                  class="avatar-img"
                  :src="require(`@/assets/img/featured/${record.Image}`)"
                  alt="User"
              /></a>
              <span class="table-head-name flex-grow-1">
                <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#profile-coach">{{
                  record.CoachName
                }}</a>
                <span class="book-active">{{ record.Booking }}</span>
              </span>
            </h2>
          </template>
          <template v-else-if="column.key === 'Date'">
            <div class="table-date-time">
              <h4>
                {{ record.Date }}<span>{{ record.Time }}</span>
              </h4>
            </div>
          </template>
          <template v-else-if="column.key === 'Payment'">
            <div>
              <span class="pay-dark fs-16">{{ record.Payment }}</span>
            </div>
          </template>
          <template v-else-if="column.key === 'Status'">
            <span :class="record.Class"
              ><i class="feather-check-square me-1"></i>{{ record.Status }}</span
            >
          </template>
          <template v-else-if="column.key === 'Details'">
            <div class="text-pink view-detail-pink">
              <a
                href="javascript:;"
                data-bs-toggle="modal"
                data-bs-target="#upcoming-coach"
                ><i class="feather-eye"></i>View Details</a
              >
            </div>
          </template>
          <template v-else-if="column.key === 'Reviews'">
            <div class="table-rating">
              <div class="rating-point">
                <i class="fas fa-star filled me-1"></i>
                <i class="fas fa-star filled me-1"></i>
                <i class="fas fa-star filled me-1"></i>
                <i class="fas fa-star filled me-1"></i>
                <i :class="record.Star"></i>
              </div>
            </div>
          </template>
          <template v-else-if="column.key === 'action'">
            <div class="text-end">
              <div class="dropdown dropdown-action table-drop-action">
                <a
                  href="javascript:void(0);"
                  class="action-icon dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  ><i class="fas fa-ellipsis-h"></i
                ></a>
                <div class="dropdown-menu dropdown-menu-end">
                  <a class="dropdown-item" href="javascript:void(0);"
                    ><i class="feather-edit"></i>Edit</a
                  >
                  <a class="dropdown-item" href="javascript:void(0);"
                    ><i class="feather-trash"></i>Delete</a
                  >
                </div>
              </div>
            </div>
          </template>
        </template>
      </a-table>
    </div>
  </div>
  <booking-coaches-modal></booking-coaches-modal>
</template>
<script>
const columns = [
  {
    title: "Coach Name",
    dataIndex: "CoachName",
    key: "CoachName",
    sorter: {
      compare: (a, b) => {
        a = a.CoachName.toLowerCase();
        b = b.CoachName.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Booking Type",
    dataIndex: "BookingType",
    sorter: {
      compare: (a, b) => {
        a = a.BookingType.toLowerCase();
        b = b.BookingType.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Date & Time",
    dataIndex: "Date",
    key: "Date",
    sorter: {
      compare: (a, b) => {
        a = a.Date.toLowerCase();
        b = b.Date.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Payment",
    dataIndex: "Payment",
    key: "Payment",
    sorter: {
      compare: (a, b) => {
        a = a.Payment.toLowerCase();
        b = b.Payment.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Status",
    dataIndex: "Status",
    key: "Status",
    sorter: {
      compare: (a, b) => {
        a = a.Status.toLowerCase();
        b = b.Status.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Details",
    dataIndex: "Details",
    key: "Details",
    sorter: {
      compare: (a, b) => {
        a = a.Details.toLowerCase();
        b = b.Details.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Reviews",
    dataIndex: "Reviews",
    key: "Reviews",
    sorter: {
      compare: (a, b) => {
        a = a.Reviews.toLowerCase();
        b = b.Reviews.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "",
    key: "action",
    sorter: true,
  },
];
const data = [
  {
    CoachName: "Angela Roudrigez",
    Booking: "Booked on : 26 May 2023",
    BookingType: "Single Lesson",
    Date: "Mon, Jul 11",
    Time: "3 days",
    Payment: "$90",
    Status: "Awaiting",
    Class: "badge bg-info",
    Details: "View Details",
    Star: "fas fa-star",
    Image: "featured-06.jpg",
  },
  {
    CoachName: "Evon Raddick",
    Booking: "Booked on : 27 May 2023",
    BookingType: "Single Lesson",
    Date: "Mon, Jul 11",
    Time: "01:00 PM - 04:00 PM",
    Payment: "$150",
    Status: "Awaiting",
    Class: "badge bg-info",
    Details: "View Details",
    Star: "fas fa-star",
    Image: "featured-07.jpg",
  },
  {
    CoachName: "Harry Richardson",
    Booking: "Booked on : 28 May 2023",
    BookingType: "Onetime",
    Date: "Mon, Jul 11",
    Time: "04:00 PM - 07:00 PM",
    Payment: "$640",
    Status: "Awaiting",
    Class: "badge bg-info",
    Details: "View Details",
    Star: "fas fa-star",
    Image: "featured-08.jpg",
  },
  {
    CoachName: "Kevin Anderson",
    Booking: "Booked on : 25 May 2023",
    BookingType: "Onetime",
    Date: "Mon, Jul 11",
    Time: "06:00 PM - 08:00 PM",
    Payment: "$120",
    Status: "Accepted",
    Class: "badge bg-success",
    Details: "View Details",
    Star: "fas fa-star filled",
    Image: "featured-05.jpg",
  },
  {
    CoachName: "Pete Hill",
    Booking: "Booked on : 29 May 2023",
    BookingType: "Onetime",
    Date: "Mon, Jul 11",
    Time: "10:00 PM - 11:00 PM",
    Payment: "$200",
    Status: "Awaiting",
    Class: "badge bg-info",
    Details: "View Details",
    Star: "fas fa-star filled",
    Image: "featured-09.jpg",
  },
];
export default {
  data() {
    return {
      data,
      columns,
    };
  },
};
</script>
